import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./home.css";
import { connect } from "react-redux";
import {
  appendQueryParamToURL,
  getAccessToken,
  getTokenExpiryTime,
  getUserEmail,
  mapDispatchToProps,
  mapStateToProps,
  getConsentTimestampEst,
  getDashboardConsentStep,
  getLoanConsentDateAccepted,
  getLoanConsentKeys,
  DASHBOARD_CONSENT_STEPS,
} from "../../../../helpers/index";
import _ from "lodash";
import Loader from "../../../../components/Loader";
import HeaderComponent from "../../../../components/HeaderComponent";

import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Button,
  Chip,
  Divider,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API_URL, COBROWSE_API_KEY } from "../../../../redux/constants";
import EConsent from "./eConsent.js";
import BorrowerAuthorizationConsent from "./BorrowerAuthorizationConsent.js";
import ConsumerConsent from "./ConsumerConsent.js";
import EConsumerConsentError from "./eConsumerConsentError.js";
import { HighlightOff, DesktopWindows, Close, CheckCircle } from "@mui/icons-material";
import { SOURCE, MOBILE_SOURCE } from "../../../../constants";
import FooterComponent from "../../../../components/FooterComponent.js";
import DeclineConfirmationPopup from "../../../../components/DeclineConfirmationPopup.js";
const CobrowseIO = require('cobrowse-sdk-js');

const isCompletedApplication = (status) =>
  status === "Completed Application" ||
  (typeof status === "string" && status.toLowerCase() === "completed");

CobrowseIO.license = COBROWSE_API_KEY; // Your actual license key
function Home(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState();
  const [expandedCardId, setExpandedCardId] = useState(null);
  const [viewButtonClicked, setViewButtonClicked] = useState(false);
  const { t } = useTranslation();
  const [eConsentConsumerCreditConsent, seteConsentConsumerCreditConsent] =
    useState({
      activeConsent: DASHBOARD_CONSENT_STEPS.E_CONSENT,
      eConsent: "",
      BorrowerAuthorizationConsent: "",
      ConsumerCreditConsent: "",
      showModels: false,
      input: "",
      load: false,
      error: false,
      loanLockStatus: false,
      eConsentEFormGenerated: null,
      lastSubmittedDateAccepted: null,
    });
  const [titleanimation, setTitleAnimation] = useState(0.3);
  // const [changeanimation, setchangeAnimation] = useState(true);
  const [declineConsentButtonName, setDeclineConsentButtonName] = useState("");
  const [isDeclinedConsent, setIsDeclinedConsent] = useState(false);
  const [screenShareOpen, setScreenShareOpen] = useState(false);
  const [screenShareCode, setScreenShareCode] = useState("");
  const [screenShareLoading, setScreenShareLoading] = useState(false);
  
  useEffect(() => {
    //Clear the errorsDictionary from redux
    props.updateErrorsDictionary({});
  }, []);
  
  useEffect(() => {
    const initialize = () => {
      localStorage.removeItem("bidentifier");
      props.showLoader(true);
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");
      if (id) {
        syncLoan(id);
      } else {
        handleLoans();
      }
    };
    const syncLoan = (id) => {
      const decodedId = decodeURIComponent(id);
      const cleanedId = decodedId.replace(/[{}]/g, "");
      props
        .syncEncompassLoanToLocalDB(cleanedId)
        .then((response) => {
          handleLoans();
        })
        .catch((error) => {
          console.error(error);
        });
    };
    initialize();
  }, [location.search]);

  useEffect(() => {
    let loans = _.get(props?.getLoansDataRes, "data");
    if (loans) {
      setData(loans);
    }
  }, [props.getLoansDataRes]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (titleanimation === 0.3) {
        setTitleAnimation(-9.3);
      } else if (titleanimation === -9.3) {
        setTitleAnimation(-19);
      } else if (titleanimation === -19) {
        setTitleAnimation(-28.2);
        // setTimeout(() => {
          // setchangeAnimation(false);
          // setTitleAnimation(0.3);
          // setTimeout(() => {
          //   setchangeAnimation(true);
          // }, 400);
        // }, 400);
      } else if (titleanimation === -28.2) {
        setTitleAnimation(-9.3);
      }
    }, 800);

    return () => {
      clearInterval(intervalId);
    };
  }, [titleanimation]);

  const handleLoans = () => {
    props.getLoans();
    props.showLoader(false);
  };
  
  const navigateTo = (input) => {
    if (expandedCardId === null || viewButtonClicked) {
      const urlWithParams = appendQueryParamToURL(
        input.applicationStatus === "InProgress"
          ? process.env.REACT_APP_LOAN_APPLN_URL
          : process.env.REACT_APP_DASHBOARD_URL
      );
      handleNavigate(input, urlWithParams);
    }
  };

  const handleViewClick = (uniqueId, event) => {
    event.stopPropagation();
    setExpandedCardId(expandedCardId === uniqueId ? null : uniqueId);
    if (event.target.tagName === "BUTTON") {
      setViewButtonClicked(true); // Set viewButtonClicked to true only if the "View" button is clicked
    } else {
      setViewButtonClicked(false); // Reset viewButtonClicked if click occurs anywhere else within the card
    }
  };

  const renderCoApplicants = (coApplicantData, userEmail) => {
    const coApplicantRows = [];

    coApplicantRows.push(
        <div className="coApplicantRow" key="coApplicantRow">
          {coApplicantData?.map((coApplicant, index) => (
              <div className="coApplicantCard" key={index}>
                <CardContent>
                  <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                    {t("Co-Applicant")} {index + 1}
                  </Typography>
                  <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />

                  {/* Borrower */}
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "2%" }}>
                    <div style={{ width: "100px", textAlign: "left" }}>
                      <Typography variant="subtitle2" style={{ color: "#808084" }}>
                        {t("Borrower")}
                      </Typography>
                      <Typography variant="subtitle2">
                        {coApplicant.borrower.email === userEmail && ` (${t("You")})`}
                      </Typography>
                    </div>
                    <div style={{ flexGrow: 1, textAlign: "left" }}>
                      <Typography variant="subtitle2">
                        {coApplicant.borrower.fullName}
                      </Typography>
                      <Typography variant="caption" style={{ wordBreak: "break-all", color: "#808084" }}>
                        {coApplicant.borrower.email}
                      </Typography>
                    </div>
                  </div>

                  {coApplicant.coBorrower && <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />}

                  {/* Co-Borrower */}
                  {coApplicant.coBorrower && (
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "100px", textAlign: "left" }}>
                          <Typography variant="subtitle2" style={{ color: "#808084" }}>
                            {t("Co Borrower")}
                          </Typography>
                          <Typography variant="subtitle2">
                            {coApplicant.coBorrower.email === userEmail && ` (${t("You")})`}
                          </Typography>
                        </div>
                        <div style={{ flexGrow: 1, textAlign: "left" }}>
                          <Typography variant="subtitle2">
                            {coApplicant.coBorrower.fullName}
                          </Typography>
                          <Typography variant="caption" style={{ wordBreak: "break-all", color: "#808084" }}>
                            {coApplicant.coBorrower.email}
                          </Typography>
                        </div>
                      </div>
                  )}
                </CardContent>
              </div>
          ))}
        </div>
    );

    return (
        <div className="coApplicantsContainer">
          <div className="coapplicant">
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              {t("Co-Applicant Details")}
            </Typography>
          </div>
          {coApplicantRows}
        </div>
    );
  };


  const renderHeaderAction = (input) => {
    if (isCompletedApplication(input.applicationStatus)) {
      return null;
    }

    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {["InProgress", "Consent Not Provided"].includes(input.applicationStatus) && (
          <Chip
            label={t(input.applicationStatus)}
            className={
              input.applicationStatus === "InProgress"
                ? "inProgressStatus"
                : "notprovided"
            }
          />
        )}
      </Box>
    );
  };

  const handleNavigate = (input, url) => {
    const appId = _.get(input, "uniqueId", undefined);
    const loanGuid = _.get(input, "loanGuid", undefined);
    let bIdent = _.get(input, "bidentifier", 0);
    localStorage.setItem("bidentifier", bIdent);
    if (appId !== undefined) {
      localStorage.setItem("userName", input.firstName + " " + input.lastName);
      localStorage.setItem("appId", input.uniqueId);
    }
    if (loanGuid !== undefined) {
      localStorage.setItem("loanGuid", input.loanGuid);
    }
    navigate(url);
  };

  const fetchIpAddress = async () => {
    const providers = [
    {
     url: "https://api4.ipify.org?format=json",
    parser: async (res) => (await res.json()).ip,
    },
    {
    url: "https://ipv4.icanhazip.com",
    parser: async (res) => (await res.text()).trim(),
    },
    {
      url: "https://ipinfo.io/json",
      parser: async (res) => (await res.json()).ip,
    },
    {
      url: "https://checkip.amazonaws.com",
      parser: async (res) => (await res.text()).trim(),
    },
    {
      url: "https://v4.ident.me",
      parser: async (res) => (await res.text()).trim(),
    },
  ];
  for (const provider of providers) {
    try {
      const response = await fetch(provider.url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const ip = await provider.parser(response);

      if (ip) {
        return ip;
      }
    } catch (error) {
      console.error("Error fetching IP address:", error);
      console.warn(`Failed to fetch IP from ${provider.url}:`, error.message);
    }
  }
  throw new Error("Unable to fetch IP from any provider.");
  };

  const getBorrowerNameParts = (fullName) => {
    const firstSpaceIndex = fullName.indexOf(" ");
    if (firstSpaceIndex === -1) {
      return { firstName: fullName, lastName: "" };
    }
    return {
      firstName: fullName.substring(0, firstSpaceIndex),
      lastName: fullName.substring(firstSpaceIndex + 1),
    };
  };

  const getConsentApiHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAccessToken()}`,
    "x-useremail": getUserEmail(),
    "x-expires-in": getTokenExpiryTime(),

  });

  const getConsentAppSource = () => window.innerWidth < 768 ? MOBILE_SOURCE : SOURCE;

  const EConsentApiCall = async (accpetedornot) => {
    seteConsentConsumerCreditConsent((prevConsents) => ({
      ...prevConsents,
      load: true,
    }));
    try {
      const ipAddress = await fetchIpAddress();
      const borId = eConsentConsumerCreditConsent.input.bidentifier;
      const fullName = getCustomerName(eConsentConsumerCreditConsent.input);
      const dateAccepted = getConsentTimestampEst();
      const body = {
        status: accpetedornot === "I Agree" ? "Accepted" : "Declined",
        borrowerId: borId,
        fullName: fullName,
        email: eConsentConsumerCreditConsent.input.userEmail,
        dateAccepted: dateAccepted,
        eFormGenerated: eConsentConsumerCreditConsent.eConsentEFormGenerated || dateAccepted,
        ipAddress: ipAddress,
        source: getConsentAppSource(),
        loanNumber: eConsentConsumerCreditConsent.input.loanNumber,
      };
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
        "x-useremail": getUserEmail(),
        "x-expires-in": getTokenExpiryTime(),
      };
      const res = await axios.post(
        `${API_URL}/customer-service/api/v1/cx/loans/${eConsentConsumerCreditConsent.input.loanGuid}/eConsent`,
        body,
        {
          headers: getConsentApiHeaders(),
        }
      );

      if (res.status === 200) {
        handleLoans();
        seteConsentConsumerCreditConsent((prevConsents) => ({
          ...prevConsents,
          load: false,
          activeConsent: DASHBOARD_CONSENT_STEPS.BORROWER_AUTHORIZATION,
          lastSubmittedDateAccepted: dateAccepted,
        }));
      }
    } catch (error) {
      seteConsentConsumerCreditConsent((prevConsents) => ({
        ...prevConsents,
        load: false,
        error: true,
      }));
    }
  };

  const BorrowerAuthorizationApiCall = async (acceptedornot) => {
    seteConsentConsumerCreditConsent((prevConsents) => ({
      ...prevConsents,
      load: true,
    }));
    try {
      const ipAddress = await fetchIpAddress();
      const input = eConsentConsumerCreditConsent.input;
      const borId = input.bidentifier;
      const fullName = getCustomerName(input);
      const { firstName, lastName } = getBorrowerNameParts(fullName);
      const dateAccepted = getConsentTimestampEst();
      const consentKeys = getLoanConsentKeys(input);
      const eFormGenerated =
        eConsentConsumerCreditConsent.lastSubmittedDateAccepted ||
        getLoanConsentDateAccepted(input, consentKeys.eConsent);
      const body = {
        status: acceptedornot === "I Agree" ? "Accepted" : "Declined",
        borrowerId: borId,
        firstName: firstName,
        lastName: lastName,
        email: input.userEmail,
        dateAccepted: dateAccepted,
        eFormGenerated: eFormGenerated,
        ipAddress: ipAddress,
        source: getConsentAppSource(),
        loanNumber: input.loanNumber,
      };
      const res = await axios.post(
        `${API_URL}/customer-service/api/v1/cx/loans/${input.loanGuid}/borrowerAuthorizationConsent`,
        body,
        { headers: getConsentApiHeaders() }
      );

      if (res.status === 200) {
        handleLoans();
        if (input.isHardConsentPresent) {
          seteConsentConsumerCreditConsent((prevConsents) => ({
            ...prevConsents,
            load: false,
            showModels: false
          }));
          // navigateTo(input);
        } else {
          seteConsentConsumerCreditConsent((prevConsents) => ({
            ...prevConsents,
            load: false,
            activeConsent: DASHBOARD_CONSENT_STEPS.CONSUMER_CREDIT,
            lastSubmittedDateAccepted: dateAccepted,
          }));
        }
      }
    } catch (error) {
      seteConsentConsumerCreditConsent((prevConsents) => ({
        ...prevConsents,
        load: false,
        error: true,
      }));
    }
  }
  const ConsumerCreidtApiCall = async (acceptedornot) => {
    seteConsentConsumerCreditConsent((prevConsents) => ({
      ...prevConsents,
      load: true,
    }));
    try {
      const ipAddress = await fetchIpAddress();
      const input = eConsentConsumerCreditConsent.input;
      const borId = input.bidentifier;
      const fullName = getCustomerName(input);
      const { firstName, lastName } = getBorrowerNameParts(fullName);
      const dateAccepted = getConsentTimestampEst();
      const consentKeys = getLoanConsentKeys(input);
      const eFormGenerated =
        eConsentConsumerCreditConsent.lastSubmittedDateAccepted ||
        getLoanConsentDateAccepted(input, consentKeys.authorization);
      const body = {
        status: acceptedornot === "I Agree" ? "Accepted" : "Declined",
        borrowerId: borId,
        firstName: firstName,
        lastName: lastName,
        email: input.userEmail,
        dateAccepted: dateAccepted,
        eFormGenerated: eFormGenerated,
        ipAddress: ipAddress,
        source: getConsentAppSource(),
        inquiryType: "Soft",
        loanNumber: eConsentConsumerCreditConsent.input.loanNumber,
      };
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getAccessToken()}`,
        "x-useremail": getUserEmail(),
        "x-expires-in": getTokenExpiryTime(),
        loanNumber: input.loanNumber,
      };

      const res = await axios.post(
        `${API_URL}/customer-service/api/v1/cx/loans/${input.loanGuid}/creditConsent`,
        body,
        {
          headers: getConsentApiHeaders(),
        }
      );

      if (res.status === 200) {
        handleLoans();
        seteConsentConsumerCreditConsent((prevConsents) => ({
          ...prevConsents,
          load: false,
          showModels: false
        }));
        // navigateTo(input);
      }
    } catch (error) {
      seteConsentConsumerCreditConsent((prevConsents) => ({
        ...prevConsents,
        load: false,
        error: true,
      }));
    }
  };

  const updateEconsent = (obtainedConsent) => {
    seteConsentConsumerCreditConsent((prevConsents) => ({
      ...prevConsents,
      eConsent: obtainedConsent,
    }));
    EConsentApiCall(obtainedConsent);
  };

  const updateBorrowerAuthorizationConsent = (obtainedConsent) => {
    seteConsentConsumerCreditConsent((prevConsents) => ({
      ...prevConsents,
      BorrowerAuthorizationConsent: obtainedConsent,
    }));
    BorrowerAuthorizationApiCall(obtainedConsent);
  }

  const updateConsumerCreditConset = (obtainedConsent) => {
    seteConsentConsumerCreditConsent((prevConsents) => ({
      ...prevConsents,
      ConsumerCreditConsent: obtainedConsent,
    }));

    ConsumerCreidtApiCall(obtainedConsent);
  };

  const getCustomerName = (input) => {
    if (input?.bidentifier?.endsWith("0")) {
      if (input.bidentifier.length === 2) {
        const coapplicant = input.coApplicants?.find(
          (applicant) => applicant.borrower.email === input.userEmail
        );
        return coapplicant?.borrower?.fullName;
      }
      return input?.borrowerFullName;
    }
    if (input?.bidentifier?.endsWith("1")) {
      if (input.bidentifier.length === 2) {
        const coapplicant = input.coApplicants?.find(
          (applicant) => applicant?.coBorrower?.email === input?.userEmail
        );
        return coapplicant?.coBorrower?.fullName;
      }
      return input?.coBorrowerFullName;
    }
  };

  const renderConsentModalContent = (modalProps) => {
    const customerName = getCustomerName(modalProps?.eConsentConsumerCreditConsent?.input);
    const { activeConsent } = eConsentConsumerCreditConsent;
    if (activeConsent === DASHBOARD_CONSENT_STEPS.E_CONSENT) {
      return (
        <>
          <EConsent coBorrowerFullName={customerName} />
          <footer>
            <button
              type="button"
              onClick={() => updateEconsent("I Agree")}
              className={
                eConsentConsumerCreditConsent.eConsent === "I Agree"
                  ? "selected"
                  : "unselected"
              }
            >
              {t("I Agree")}
            </button>
            <button
              type="button"
              onClick={() => triggerDeclineConsentPopup("eConsent")}
              className={
                eConsentConsumerCreditConsent.eConsent === "I Decline"
                  ? "selected"
                  : "unselected"
              }
            >
              {t("I Decline")}
            </button>
          </footer>
        </>
      );
    }

    if (activeConsent === DASHBOARD_CONSENT_STEPS.BORROWER_AUTHORIZATION) {
      return (
        <>
          <BorrowerAuthorizationConsent coBorrowerFullName={customerName} />
          <footer>
            <button
              type="button"
              onClick={() => updateBorrowerAuthorizationConsent("I Agree")}
              className={
                eConsentConsumerCreditConsent.BorrowerAuthorizationConsent ===
                "I Agree"
                  ? "selected"
                  : "unselected"
              }
            >
              {t("I Agree")}
            </button>
            <button
              type="button"
              onClick={() =>
                triggerDeclineConsentPopup("borrowerCertificationAuthorizationConsent")
              }
              className={
                eConsentConsumerCreditConsent.BorrowerAuthorizationConsent ===
                "I Decline"
                  ? "selected"
                  : "unselected"
              }
            >
              {t("I Decline")}
            </button>
          </footer>
        </>
      );
    }

    return (
      <>
        <ConsumerConsent coBorrowerFullName={customerName} />
        <footer>
          <button
            type="button"
            onClick={() => updateConsumerCreditConset("I Agree")}
            className={
              eConsentConsumerCreditConsent.ConsumerCreditConsent === "I Agree"
                ? "selected"
                : "unselected"
            }
          >
            {t("I Agree")}
          </button>
          <button
            type="button"
            onClick={() => triggerDeclineConsentPopup("Consumer Credit Consent")}
            className={
              eConsentConsumerCreditConsent.ConsumerCreditConsent === "I Decline"
                ? "selected"
                : "unselected"
            }
          >
            {t("I Decline")}
          </button>
        </footer>
      </>
    );
  }

  const EConsentConsumerCreditConsent = useMemo(
    () => (props) => {
      return (
        <Box className="eConsent-modelbox-main-con">
          <Box className="eConsentModalShadow"></Box>
          {eConsentConsumerCreditConsent.load === true ? (
            <Loader />
            ) : eConsentConsumerCreditConsent.loanLockStatus ? (
            <Box className="eConsent-modelbox">
              <span>{eConsentConsumerCreditConsent.input}</span>
              <footer>
                <button
                  type="button"
                  onClick={() =>
                    seteConsentConsumerCreditConsent((prevConsents) => ({
                      ...prevConsents,
                      showModels: false,
                      loanLockStatus: false,
                    }))
                  }
                  className="selected"
                  style={{ marginRight: 0 }}
                >
                  {t("Close")}
                </button>
              </footer>
            </Box>
          ) : eConsentConsumerCreditConsent.error === true ? (
            <EConsumerConsentError
              setErrorState={seteConsentConsumerCreditConsent}
            />
          ) : (
            <Box className="eConsent-modelbox">
              <div className="econsent-modal-closeIcon">
                <HighlightOff
                  onClick={() =>
                    seteConsentConsumerCreditConsent((prevConsents) => ({
                      ...prevConsents,
                      showModels: false,
                      loanLockStatus: false,
                    }))
                  }
                />
              </div>
              {renderConsentModalContent(props)}
            </Box>
          )}
        </Box>
      );
    },
    [eConsentConsumerCreditConsent]
  );

  const onCardClickFunc = (input) => {
    if (input.applicationStatus === "Consent Not Provided") {
      const activeConsent = getDashboardConsentStep(input);
      if (!activeConsent) {
        navigateTo(input);
        return;
      }
      seteConsentConsumerCreditConsent((prevConsents) => ({
        ...prevConsents,
        load: false,
        showModels: true,
        loanLockStatus: false,
        input: input,
        activeConsent: activeConsent,
        eConsentEFormGenerated:
          activeConsent === DASHBOARD_CONSENT_STEPS.E_CONSENT
            ? getConsentTimestampEst()
            : null,
        lastSubmittedDateAccepted: null,
        eConsent: "",
        BorrowerAuthorizationConsent: "",
        ConsumerCreditConsent: "",
        error: false,
      }));
    } else {
      navigateTo(input);
    }
  };
  const handleDeclineConsent = (action) => {
    if(action === "Confirm") {
      if(declineConsentButtonName === "eConsent") {
        updateEconsent("I Decline");
        setDeclineConsentButtonName("");
      } else if(
        declineConsentButtonName === "borrowerCertificationAuthorizationConsent"
      ) {
        updateBorrowerAuthorizationConsent("I Decline");
        setDeclineConsentButtonName("");
      } else if(declineConsentButtonName === "Consumer Credit Consent") {
        updateConsumerCreditConset("I Decline");
        setDeclineConsentButtonName("");
      }
      setIsDeclinedConsent(false);
    } else if(action === "Cancel") {
      setIsDeclinedConsent(false);
      setDeclineConsentButtonName("");
    }
  }
  const triggerDeclineConsentPopup = (buttonName) => {
    setIsDeclinedConsent(true);
    setDeclineConsentButtonName(buttonName);
  }
  const disableCreateNewApplication = () => {
    // Get the current URL
    const url = new URL(window.location.href);
    // Check if there is a query parameter named "lar"
    const hasLarQueryParam = url.searchParams.has("lar");
    // Enable button if the path is "/cx/" and the query is either empty or contains "?lar"
    if (hasLarQueryParam) {
      return false; // Enable the button
    } else {
      return true; // Disable the button
    }
  };

  const generateScreenShareCode = async () => {
    // Call start when your app is ready
    CobrowseIO.start();
    try {
      // Ensure that Cobrowse client is available and initialized
      await CobrowseIO.client();
      
      // Only generate the code when it's needed (on button click)
      const code = await CobrowseIO.createSessionCode();
      return code;
      // You can now display the code to the user
    } catch (error) {
      console.error('Error starting Cobrowse session:', error);
      throw error; // Re-throw to handle in calling function
    }
  };

  const handleScreenShareClick = async () => {
    try {
      setScreenShareOpen(true);
      setScreenShareLoading(true);
      setScreenShareCode(""); // Clear previous code
      const code = await generateScreenShareCode();
      if (code) {
        // Format code as "XXX XXX XXX" if it's not already formatted
        const formattedCode = typeof code === 'string' && code.length === 9 && !code.includes(' ')
          ? `${code.slice(0, 3)} ${code.slice(3, 6)} ${code.slice(6, 9)}`
          : code;
        setScreenShareCode(formattedCode);
      }
    } catch (error) {
      console.error('Error generating screen share code:', error);
      // Optionally show an error message to the user
      setScreenShareOpen(false);
    } finally {
      setScreenShareLoading(false);
    }
  };

  const handleScreenShareClose = () => {
    setScreenShareOpen(false);
    setScreenShareCode("");
  };

  // const handleScreenShareStart = () => {
  //   handleScreenShareClose();
  // };
  // const displayLoanCard = (input) => {
  //   const getRequiredPath = localStorage.getItem("requiredPath");

  //   if(getRequiredPath) {
  //     if (input?.hidden !== undefined && input?.hidden !== true) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return true;
  //   }
  // };
  const displayLoanCard = (input) => {
    const getRequiredPath = localStorage.getItem("requiredPath");

    if (getRequiredPath) {
        // Create a URLSearchParams object to parse query string from requiredPath
        const urlParams = new URLSearchParams(getRequiredPath);

        // Check if both 'authentication' and 'token' exist in the URL query string
        if (urlParams.has("authentication") && urlParams.has("token")) {
            if (input?.hidden !== undefined && input?.hidden !== true) {
                return true;
            } else {
                return false;
            }
        } else {
            // If required parameters are missing, return true
            return true;
        }
    } else {
        // If requiredPath is not found in localStorage, return true
        return true;
    }
};
  return (
    <div>
      <div className="mainCardDiv">
        {props.toggleLoader && <Loader />}
        {eConsentConsumerCreditConsent.showModels && (
          <EConsentConsumerCreditConsent
            eConsentConsumerCreditConsent={eConsentConsumerCreditConsent}
          />
        )}
        <HeaderComponent />
        <div className="headerDiv">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "14px",
            }}
          >
            {/* <Typography className="title">
              {t('Your Mortgage')}
              {changeanimation ? <span style={changeanimation ? { marginTop: `${titleanimation}%` } : { marginTop: `${titleanimation}%`, transition: `all .0s linear` }} className="titleanimation">
                <span style={titleanimation === 0.3 ? { opacity: "100%" } : { opacity: "0%" }} className={titleanimation === 0.3 ? "displayBlock" : "displayNone"}>{t('Organized')}...</span>
                <span style={titleanimation === -9.3 ? { opacity: "100%" } : { opacity: "0%" }} className={titleanimation === -9.3 ? "displayBlock" : "displayNone"}>{t('Simplified')}...</span>
                <span style={titleanimation === -19 ? { opacity: "100%" } : { opacity: "0%" }} className={titleanimation === -19 ? "displayBlock" : "displayNone"}>{t('Amplified')}...</span>
                <span style={titleanimation === -28.2 ? { opacity: "100%" } : { opacity: "0%" }} className={titleanimation === -28.2 ? "displayBlock" : "displayNone"}>{t('Organized')}...</span>
              </span> :
                <span style={{ marginTop: `0.3%` }} className="titleanimation-2">
                  <span>{t('Organized')}...</span>
                </span>
              }

            </Typography> */}
            <Typography className="title">
              <span>{t("Your Mortgage")}</span>
              {/* {changeanimation ? ( */}
                <span
                  style={{
                    marginTop: `${titleanimation}%`,
                    transition: "all 0.3s ease",
                  }}
                  className="titleanimation"
                >
                  <span
                    style={{
                      opacity: titleanimation === 0.3 ? "100%" : "0%",
                    }}
                    className={
                      titleanimation === 0.3 ? "displayBlock" : "displayNone"
                    }
                  >
                    {t("Organized")}...
                  </span>
                  <span
                    style={{
                      opacity: titleanimation === -9.3 ? "100%" : "0%",
                    }}
                    className={
                      titleanimation === -9.3 ? "displayBlock" : "displayNone"
                    }
                  >
                    {t("Simplified")}...
                  </span>
                  <span
                    style={{
                      opacity: titleanimation === -19 ? "100%" : "0%",
                    }}
                    className={
                      titleanimation === -19 ? "displayBlock" : "displayNone"
                    }
                  >
                    {t("Amplified")}...
                  </span>
                  <span
                    style={{
                      opacity: titleanimation === -28.2 ? "100%" : "0%",
                    }}
                    className={
                      titleanimation === -28.2 ? "displayBlock" : "displayNone"
                    }
                  >
                    {t("Organized")}...
                  </span>
                </span>
              {/* ) : (
                <span
                  style={{ marginTop: `0.3%` }}
                  className={i18n.language.includes("en") ? "titleanimation-2 en-ml" : "titleanimation-2 es-ml"}
                >
                  <span>{t("Organized")}...</span>
                </span>
              )} */}
            </Typography>

            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "19.36px",
                color: "#9E9E9E",
              }}
              align="center"
            >{t(
                `Unlock your path to homeownership with our tailored mortgage solutions. We're here to guide you through the journey of securing your dream home.`
              )}
            </Typography>
          </Box>
        </div>
        <div className="applicationsDataMainDiv">
          <Paper
            sx={{
              display: {
                sm: "block",
                xs: "none",
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          >
            {data?.length > 0 && disableCreateNewApplication() &&(
              <span className="invalidUrlText">
                {t("Please click the loan card below to provide econsent")}
              </span>
             )}
          </Paper>
        </div>
        <div className="applicationsDataMainDiv">
          <Paper
            sx={{
              display: { xs: "grid", sm: "none" },
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            {data?.length > 0 && disableCreateNewApplication() && (
              <span className="invalidUrlText">
                {t("Please click the loan card below to provide econsent")}
              </span>
            )}
            <br />
          </Paper>
          <Box
            className="typo"
            style={{
              display: "flex",
              flexDirection: "column",
              // justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "20px",
              padding: { xs: 0, sm: "0 3vw" },
              width: "100%"
            }}
          >
            <Typography variant="h5">{t("Your Mortgage")}:</Typography>
            <Paper
              sx={{
                display: {
                  sm: "block",
                  xs: "none",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  margin: 'auto'
                },
              }}
            >
            {!disableCreateNewApplication() && (
              <Button
                className="createButton"
                onClick={() => {
                  window.localStorage.setItem("stepperLength", 6);
                  if(window.localStorage.getItem("stepperLength") === "6") {
                    navigateTo({ applicationStatus: "InProgress" });
                  }
                }}
              >
                {t("Create New Application")}
              </Button>
            )}
            </Paper>
          </Box>
          {!disableCreateNewApplication() && (
          <Paper
            sx={{
              display: { xs: "block", sm: "none" },
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <Button
              className="createButton"
              onClick={() => {
                window.localStorage.setItem("stepperLength", 5);
                if(window.localStorage.getItem("stepperLength") === "5") {
                  navigateTo({ applicationStatus: "InProgress" });
                }
              }}
            >
              + {t("Create New Application")}
            </Button>
          </Paper>
          )}
          <div className="applicationsDataDiv">
            {typeof data === "object" && data?.length > 0 ? (
              data?.map((input, index) => (
                (displayLoanCard(input)) && (
                <Card
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: expandedCardId === input.uniqueId ? "100%" : "auto",
                    height:
                      expandedCardId === input.uniqueId ||
                      isCompletedApplication(input.applicationStatus)
                        ? "auto"
                        : "250px",
                    borderRadius: "10px",
                    marginBottom: "10px",
                    cursor: "pointer",
                    overflow: "visible",
                  }}
                  className="cardRootClassName"
                  onClick={() => onCardClickFunc(input)}
                >
                  {isCompletedApplication(input.applicationStatus) && (
                    <div className="consentsProvidedBanner">
                      <CheckCircle className="consentsProvidedBannerIcon" />
                      <span>{t("Consent Provided")}</span>
                    </div>
                  )}
                  <CardHeader
                    title={t("Loan No.")}
                    subheader={input.loanNumber}
                    titleTypographyProps={{
                      color: "textSecondary",
                      variant: "subtitle1",
                    }}
                    subheaderTypographyProps={{
                      color: "textPrimary",
                      variant: "subtitle2",
                    }}
                    action={renderHeaderAction(input)}
                  />
                  {(input?.applicationStatus !== "InProgress" && input?.subjectPropertyAddress) && (
                    <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingBottom: '8px' }}>
                    <Typography color="textSecondary" variant="subtitle1">
                      {t("Property Address")}:{" "}
                      <b>{input?.subjectPropertyAddress ? input?.subjectPropertyAddress : ""}</b>
                    </Typography>
                    </div>
                  )}
                  <Divider />
                  <div className="coApplicantsViewDiv" style={{ flex: 1 }}>
                    <div className="cardContentMainDivClassName">
                      <CardContent style={{ flex: 1, paddingBottom: "8px" }}>
                        {input.bidentifier === "0" ? (
                          <Typography color="textSecondary" variant="subtitle1">
                            {t("Borrower Name")}:{" "}
                            <b>{input.borrowerFullName}</b> ( {t("You")})
                          </Typography>
                        ) : (
                          <Typography color="textSecondary" variant="subtitle1">
                            {t("Borrower Name")}:{" "}
                            <b>{input.borrowerFullName}</b>
                          </Typography>
                        )}
                        {input.coBorrowerFullName !== "" &&
                          (input?.bidentifier === "1" ? (
                            <Typography
                              color="textSecondary"
                              variant="subtitle1"
                            >
                              {t("Co-Borrower Name")}:{" "}
                              <b>{input.coBorrowerFullName}</b> ( {t("You")} )
                            </Typography>
                          ) : (
                            <Typography
                              color="textSecondary"
                              variant="subtitle1"
                            >
                              {t("Co-Borrower Name")}:{" "}
                              <b>{input.coBorrowerFullName}</b>
                            </Typography>
                          ))}
                        {input?.coApplicants?.length > 0 &&
                          input?.coApplicants.map(
                            (each) =>
                              each.userEmail === input.userEmail && (
                                <Typography
                                  color="textSecondary"
                                  variant="subtitle1"
                                >
                                  {t("Co-Applicants")}:{" "}
                                  <b>{each.borrowerFullName}</b> ( {t("You")} )
                                </Typography>
                              )
                          )}
                        {input?.coApplicants?.length > 0 && (
                          <Typography
                            color="textSecondary"
                            variant="subtitle1"
                            className="viewCoAPplicantsTextDiv"
                          >
                            <Button
                              onClick={(event) =>
                                handleViewClick(input.uniqueId, event)
                              }
                              style={{
                                textTransform: "none",
                                color: "#125437",
                                width: "100%",
                              }}
                            >
                              {t("View Co-Applicants")}(
                              {input?.coApplicants?.length})
                            </Button>
                          </Typography>
                        )}
                        {expandedCardId === input.uniqueId && (
                          <Box
                            sx={{
                              display: "flex",
                              marginTop: "5%",
                              gap: "10px",
                            }}
                          >
                            <Button
                              onClick={(event) => handleViewClick(null, event)}
                              variant="outlined"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#e9f6f1",
                                color: "#125437",
                                border: "1px solid #125437",
                              }}
                            >
                              {t("Close")}
                            </Button>
                            <Button
                              onClick={() => {
                                if (
                                  input.applicationStatus ===
                                  "Consent Not Provided"
                                ) {
                                  onCardClickFunc(input);
                                } else {
                                  navigateTo(input);
                                }
                              }}
                              variant="outlined"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#125437",
                                color: "#ffffff",
                                border: "1px solid #125437",
                              }}
                            >
                              {t("Open")}
                            </Button>
                          </Box>
                        )}
                      </CardContent>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      {expandedCardId === input.uniqueId &&
                        input.coApplicants &&
                        input.coApplicants.length > 0 && (
                          <>
                            <CardContent
                              style={{
                                flex: 1,
                                minWidth: 200,
                                display: "flex",
                                flexDirection: "column",
                                padding: 0,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Box sx={{ flexGrow: 1 }} />
                              {renderCoApplicants(
                                input.coApplicants,
                                input.userEmail
                              )}
                            </CardContent>
                          </>
                        )}
                    </div>
                  </div>
                  {isCompletedApplication(input.applicationStatus) && (
                    <div className="viewLoanButtonRow">
                      <Button
                        className="viewLoanButton"
                        onClick={(event) => {
                          event.stopPropagation();
                          navigateTo(input);
                        }}
                      >
                        {t("Click Here to View Loan")}
                      </Button>
                    </div>
                  )}
                </Card>
              )))
            ) : (
              <Box
                style={
                  data?.length > 0
                    ? { paddingLeft: "3vw" }
                    : {
                        textAlign: "center",
                        width: "95vw",
                        marginBottom: "2rem",
                      }
                }
                >{
                    !disableCreateNewApplication() &&
                    (<Typography
                      variant="body1"
                      align="center"
                      color="textSecondary"
                      fontSize="large"
                    >
                      {t(
                        "You don't have any mortgage history. Please click 'Create New Application' to start one."
                      )}
                    </Typography>)
                  }
              </Box>
            )}
          </div>
        </div>
      </div>
      
      {/* Fixed Screen Share Button */}
      {/* <Button
        className="screen-share-fixed-button"
        onClick={handleScreenShareClick}
        startIcon={<DesktopWindows />}
      >
        {t("Screen Share")}
      </Button> */}

      {/* Screen Share Popup Dialog */}
      {/* {screenShareOpen && (
        <Box 
          className="screen-share-popup-overlay"
          onClick={handleScreenShareClose}
        >
          <Box 
            className="screen-share-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <Box className="screen-share-popup-header">
              <Typography variant="h5" className="screen-share-popup-title">
                {t("Start screenshare")}
              </Typography>
              <Close 
                className="screen-share-close-icon" 
                onClick={handleScreenShareClose}
              />
            </Box>
            
            <Box className="screen-share-popup-body">
              <Typography variant="body1" className="screen-share-instructions">
                {t("Provide this code to your Bond Street Mortgage team member to initiate screen sharing")}
              </Typography>
              
              <Box className="screen-share-code-container">
                {screenShareLoading ? (
                  <Typography variant="h3" className="screen-share-code">
                    {t("Loading...")}
                  </Typography>
                ) : (
                  <Typography variant="h3" className="screen-share-code">
                    {screenShareCode || "- - -"}
                  </Typography>
                )}
              </Box>
              <Typography variant="body2" className="screen-share-explanation">
                {t("screenShareContent")}
              </Typography>
            </Box>
            
            <Box className="screen-share-popup-footer">
              <Button
                className="screen-share-cancel-button"
                onClick={handleScreenShareClose}
              >
                {t("Cancel")}
              </Button> */}
              {/* <Button
                className="screen-share-start-button"
                onClick={handleScreenShareStart}
                disabled={screenShareLoading || !screenShareCode}
              >
                {t("Start")}
              </Button> */}
            {/* </Box>
          </Box>
        </Box>
      )} */}
      
      <FooterComponent />
       {isDeclinedConsent && (
        <DeclineConfirmationPopup
          open={isDeclinedConsent}
          handleClose={(action) => handleDeclineConsent(action)}
          declineConsentButtonName={declineConsentButtonName}
        />
      )}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
export { Home };
